/** Prolean dynamic product benefits card. */
(() => {
  'use strict';
  if (window.__proleanBenefitsCard) return;
  window.__proleanBenefitsCard = true;

  const HOST = '.prolean-purchase-reassurance';
  const OPTIONS = '.shopify_subscriptions_app_block_purchase_options';
  const LABEL = '.shopify_subscriptions_app_block_label';
  const cards = new WeakMap();
  const clean = (v) => String(v || '').replace(/\s+/g, ' ').trim();
  const number = (v) => {
    const s = clean(v).replace(/[^0-9.,-]/g, '');
    if (!s) return 0;
    const n = s.lastIndexOf(',') > s.lastIndexOf('.')
      ? parseFloat(s.replace(/\./g, '').replace(',', '.'))
      : parseFloat(s.replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  };
  const sectionFor = (n) => n.closest('product-info') || n.closest('.shopify-section');
  const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };

  function optionData(section) {
    const options = section.querySelector(OPTIONS);
    // Selection is authoritative via the .prolean-selected class (the app can
    // leave One-time's radio :checked even when a subscription is chosen).
    const label = options?.querySelector(LABEL + '.prolean-selected')
      || options?.querySelector('input[type="radio"]:checked')?.closest(LABEL)
      || options?.querySelector(LABEL);
    const oneTime = !label || !!label.querySelector('input[data-radio-type="one_time_purchase"]');
    let script = label?.querySelector('script');
    if (!script && label?.nextElementSibling?.tagName === 'SCRIPT') script = label.nextElementSibling;
    let price = 0;
    let compare = 0;
    try {
      const data = JSON.parse(script?.textContent || '{}');
      price = number(data.price);
      compare = number(data.comparedAtPrice);
    } catch (_) {}
    if (!price) {
      const root = section.querySelector('[id^="price-"] .price, .product__info-container .price');
      const sale = root?.classList.contains('price--on-sale');
      const el = sale
        ? root.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last')
        : root?.querySelector('.price__regular .price-item--regular');
      price = number(el?.textContent || root?.textContent);
    }
    if (!compare) compare = price;
    const discount = !oneTime && compare > price ? Math.round((compare - price) / compare * 100) : 0;
    return { oneTime, price, discount };
  }

  function quantity(section) {
    const input = section.querySelector('quantity-input input[name="quantity"], input[name="quantity"]');
    const n = parseInt(input?.value || '1', 10);
    return n > 0 ? n : 1;
  }

  function currency(value) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
      }).format(value);
    } catch (_) { return `$${value.toFixed(2)}`; }
  }

  const row = (icon, html, cls = '') =>
    `<span class="prolean-benefits__row ${cls}"><span class="prolean-benefits__icon" aria-hidden="true">${icon}</span><span>${html}</span></span>`;

  function cardHtml() {
    return `<span class="prolean-benefits__head"><strong data-pb-title>Your Prolean Benefits</strong><span aria-hidden="true">›</span></span>
      <span data-pb-sub hidden>
        ${row('✦', '<strong>Extra 15% off</strong> your first qualifying subscription order', 'is-bonus')}
        ${row('↻', '<strong data-pb-saving>Subscription savings</strong> on recurring shipments')}
      </span>
      <span class="prolean-benefits__rows">
        ${row('★', '<strong data-pb-points>Earn Prolean Rewards</strong><span data-pb-value></span><small class="prolean-benefits__fine" data-pb-fine style="display:none;margin-top:.3rem;font-size:1.05rem;line-height:1.35;font-weight:400;color:rgba(var(--color-foreground),.6)"></small>')}
        ${row('→', '<strong>Free Economy shipping</strong> on qualifying U.S. orders $50+')}
        ${row('✓', '<strong>Secure checkout</strong> powered by Shopify')}
      </span>
      <span class="prolean-benefits__more">View rewards, subscription savings, and benefits →</span>`;
  }

  function modalHtml(id) {
    return `<dialog class="prolean-benefits-modal" id="${id}" aria-labelledby="${id}-title">
      <div class="prolean-benefits-modal__panel">
        <header><div><small>PROLEAN WELLNESS</small><h2 id="${id}-title">Purchase Benefits</h2></div><button type="button" data-pb-close aria-label="Close">×</button></header>
        <div class="prolean-benefits-modal__body">
          <section><b aria-hidden="true">★</b><div><h3>Rewards on every eligible purchase</h3><p>Earn 10 Prolean Rewards points for every $1 spent—approximately 10% back in rewards.</p><p class="is-estimate" data-pb-estimate></p><p class="is-fine">Final points are based on the eligible amount paid after discounts and adjustments. Taxes, shipping, refunds, and canceled items do not earn rewards.</p></div></section>
          <section><b aria-hidden="true">✦</b><div><h3>Subscribe &amp; Save</h3><p>New subscribers receive an extra 15% off their first qualifying subscription order, in addition to the selected recurring subscription savings.</p><p data-pb-subtext></p><p>Subscribers continue earning rewards on the eligible amount actually paid.</p></div></section>
          <section><b aria-hidden="true">↻</b><div><h3>Flexible delivery</h3><p>Eligible subscriptions may be skipped, paused, changed, or canceled according to the subscription terms.</p></div></section>
          <section><b aria-hidden="true">→</b><div><h3>Shipping</h3><p>Free Economy shipping is available on qualifying U.S. orders of $50 or more after applicable discounts. Eligibility is confirmed at checkout.</p></div></section>
          <section><b aria-hidden="true">✓</b><div><h3>Secure checkout</h3><p>Payments and checkout are securely processed through Shopify.</p></div></section>
        </div>
        <footer><button type="button" class="button button--primary" data-pb-close>Continue shopping</button></footer>
      </div>
    </dialog>`;
  }

  function update(c) {
    if (!c.wrap.isConnected) return;
    const state = optionData(c.section);
    const qty = quantity(c.section);
    const points = Math.max(0, Math.round(state.price * qty * 10));
    const value = currency(points / 100);
    const sub = c.card.querySelector('[data-pb-sub]');
    setText(c.card.querySelector('[data-pb-title]'), state.oneTime ? 'Your Prolean Benefits' : 'Your Subscriber Benefits');
    if (sub.hidden === !state.oneTime) sub.hidden = state.oneTime;
    c.card.classList.toggle('is-subscription', !state.oneTime);
    setText(c.card.querySelector('[data-pb-saving]'), state.discount ? `Save ${state.discount}%` : 'Subscription savings');

    // Rewards estimate. One-time: exact. Subscription: the storefront cannot know
    // whether the buyer qualifies as a first-time subscriber (extra 15% off the
    // first order) before checkout, so show a non-numeric, always-true message.
    const pointsEl = c.card.querySelector('[data-pb-points]');
    const valueEl = c.card.querySelector('[data-pb-value]');
    const fineEl = c.card.querySelector('[data-pb-fine]');
    if (state.oneTime) {
      setText(pointsEl, `Earn approximately ${points.toLocaleString()} Prolean Rewards points`);
      setText(valueEl, ` — a ${value} value${qty > 1 ? ` for ${qty} items` : ''}`);
      if (fineEl) fineEl.style.display = 'none';
    } else {
      setText(pointsEl, 'Earn Prolean Rewards on this order');
      setText(valueEl, '');
      if (fineEl) {
        setText(fineEl, 'Final points are calculated from the amount paid after subscription and promotional discounts.');
        fineEl.style.display = 'block';
      }
    }

    setText(c.modal.querySelector('[data-pb-estimate]'), state.oneTime
      ? `This selection is estimated to earn approximately ${points.toLocaleString()} points, a ${value} rewards value.`
      : `Recurring shipments are estimated to earn approximately ${points.toLocaleString()} points (${value} value) based on the subscription price. Your first order applies the extra first-order discount, so final points are calculated from the amount actually paid.`);
    setText(c.modal.querySelector('[data-pb-subtext]'), state.discount
      ? `Your selected subscription saves ${state.discount}% on recurring shipments. The extra 15% applies to the first qualifying subscription order.`
      : 'Choose a subscription option to see its recurring savings. The extra 15% applies to the first qualifying subscription order.');
  }

  function schedule(c) {
    if (c.pending) return;
    c.pending = true;
    requestAnimationFrame(() => { c.pending = false; update(c); });
  }

  function enhance(host) {
    const section = sectionFor(host);
    if (!section) return;
    const id = `ProleanBenefits-${clean(section.dataset.section || section.id || Math.random().toString(36).slice(2)).replace(/[^\w-]/g, '')}`;
    const wrap = document.createElement('div');
    wrap.className = 'prolean-benefits-wrap';
    wrap.innerHTML = `<button type="button" class="prolean-benefits-card" aria-haspopup="dialog" aria-controls="${id}">${cardHtml()}</button>${modalHtml(id)}`;
    host.replaceWith(wrap);
    const card = wrap.querySelector('.prolean-benefits-card');
    const modal = wrap.querySelector('.prolean-benefits-modal');
    const c = { section, wrap, card, modal, pending: false };
    cards.set(wrap, c);
    let opener;
    const close = () => modal.open && modal.close ? modal.close() : modal.removeAttribute('open');
    card.addEventListener('click', () => {
      opener = document.activeElement;
      modal.showModal ? modal.showModal() : modal.setAttribute('open', '');
    });
    modal.querySelectorAll('[data-pb-close]').forEach((b) => b.addEventListener('click', close));
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    modal.addEventListener('close', () => opener?.focus?.({ preventScroll: true }));
    section.addEventListener('change', () => schedule(c), true);
    section.addEventListener('input', () => schedule(c), true);
    section.addEventListener('click', () => setTimeout(() => schedule(c), 50), true);
    new MutationObserver(() => schedule(c)).observe(section, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    update(c);
    [80, 300, 900].forEach((ms) => setTimeout(() => schedule(c), ms));
  }

  function init(root = document) {
    root.querySelectorAll?.(HOST).forEach(enhance);
    document.querySelectorAll('.prolean-benefits-wrap').forEach((w) => { const c = cards.get(w); if (c) schedule(c); });
  }

  let pending = false;
  const page = new MutationObserver((records) => {
    if (pending || !records.some((r) => r.addedNodes.length)) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; init(); });
  });
  const start = () => { init(); page.observe(document.body, { childList: true, subtree: true }); };
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();
